import React, {useEffect, useState} from 'react';
import {NotifyStatus} from "@app/constants/Common";

const NotificationStatus = (props) => {
    const [status, setStatus] = useState(0);
    const [size, setSize] = useState(14);

    const {value} = props
    const {fontSize} = props

    useEffect(() => {
        setStatus(value)
        if (fontSize) {
            setSize(fontSize)
        }
    }, [value]);

    return (
        <>
            {status === NotifyStatus.WAITING &&
                <div className="px-1 bg-info text-white text-center" style={{borderRadius: 5, fontSize: size, minWidth: 75}}>Chờ duyệt</div>
            }
            {status === NotifyStatus.APPROVED &&
                <div className="px-1 bg-gray text-white text-center" style={{borderRadius: 5, fontSize: size, minWidth: 75}}>Đã duyệt</div>
            }
            {status === NotifyStatus.REJECTED &&
                <div className="px-1 bg-danger text-white text-center" style={{borderRadius: 5, fontSize: size, minWidth: 75}}>Từ chối</div>
            }
        </>
    )
}

export default NotificationStatus;